$('.events__container').each(function () {
	var mySwiperEvent = new Swiper('.events__container', {
		loop: false,
		slidesPerView: 3,
		spaceBetween: 37,
		autoHeight: true,
		breakpoints: {
			480: {
				slidesPerView: 1,
				spaceBetween: 20,
				autoHeight: true
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 20
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: 20
			}
		},
		navigation: {
			nextEl: '.swiper-navs__next',
			prevEl: '.swiper-navs__prev',
		},
		on: {
			init: function () {
				if (this.slides.length <= 3) {
					$('.swiper-navs-event').fadeOut();
				} else {
					$('.swiper-navs-event').fadeIn();
				}
			},
		},
	});

});

$('.park__container').each(function () {
	var mySwiperPark = new Swiper('.park__container', {
		loop: false,
		slidesPerView: 4,
		spaceBetween: 8,
		touchRatio: 0,
		breakpoints: {
			320: {
				slidesPerView: 1,
				touchRatio: 1
			},
			480: {
				slidesPerView: 1,
				spaceBetween: 18,
				touchRatio: 1
			},
			1054: {
				slidesPerView: 'auto',
				spaceBetween: 8,
				touchRatio: 1
			}
		},
		navigation: {
			nextEl: '.swiper-navs__next',
			prevEl: '.swiper-navs__prev',
		},
		on: {
			init: function () {
				parkSliderNavs(this);
			},
			resize: function () {
				parkSliderNavs(this);
				this.slideTo(0, 500);
			}
		},
	});

	function parkSliderNavs(_this) {
		if (_this.slides.length <= 4 && window.innerWidth > 1054) {
			$('.swiper-navs-park').fadeOut();
		} else {
			$('.swiper-navs-park').fadeIn();
		}
	}

	parkSliderNavs(mySwiperPark);

});

$('.plane-page').each(function () {
	var mySwiperPlan = new Swiper('.plan__slider', {
		loop: false,
		slidesPerView: 3,
		spaceBetween: 37,
		navigation: {
			nextEl: '.swiper-navs__next',
			prevEl: '.swiper-navs__prev',
		},
		breakpoints: {
			480: {
				slidesPerView: 1,
				spaceBetween: 20,
				autoHeight: true
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 15
			},
		}
	})
});


$('.js-certificate-slide').each(function () {
	var certificate = new Swiper('.js-certificate-slide',{
		loop: false,
		slidesPerView: 3,
		spaceBetween: 45,
		normalizeSlideIndex: false,
		breakpoints: {
			1164: {
				spaceBetween: 15,
				slidesPerView: 'auto',
			}
		}
	});

	var $prev = $('.js-certificate__prev'),
		$next = $('.js-certificate__next');

	$prev.on('click', function(){
		certificate.slidePrev(300, true);
	});
	$next.on('click', function(){
		certificate.slideNext(300, true);
	});
});


$('.js-direction').each(function () {
	 var direction = new Swiper('.js-direction',{
		loop: true,
		slidesPerView: 'auto',
		spaceBetween: 84,
		centeredSlides: true,
	});

	var plane = new Swiper('.js-plane',{
		loop: true,
		slidesPerView: 'auto',
		spaceBetween: 60,
		centeredSlides: true,
		on: {
			slideNextTransitionStart: function () {
				if (direction) direction.slideNext(300);
			},
			slidePrevTransitionStart: function () {
				if (direction) direction.slidePrev(300);
			}
		}
	});
});


$('.js-paralax-slider').each(function () {
	var interleaveOffset = 0.5;

	var paralax = new Swiper('.js-paralax-slider', {
		loop: true,
		speed: 1000,
		initialSlide: 0,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		autoHeight: true,
		grabCursor: false,
		simulateTouch: true,
		watchSlidesProgress: true,
		navigation: {
			nextEl: '.js-paralax-next',
			prevEl: '.js-paralax-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true
		},
		breakpoints: {
			700: {
				simulateTouch: true
			}
		},
		on: {
			init: function(){
				this.autoplay.stop();
			},
			progress: function(){
				var swiper = this;
				for (var i = 0; i < swiper.slides.length; i++) {
					var slideProgress = swiper.slides[i].progress,
						innerOffset = swiper.width * interleaveOffset,
						innerTranslate = slideProgress * innerOffset;
					swiper.slides[i].querySelector('.paralax-slider__img').style.transform =
						'translate3d(' + innerTranslate + 'px, 0, 0)';
				}
			},
			touchStart: function() {
				var swiper = this;
				for (var i = 0; i < swiper.slides.length; i++) {
					swiper.slides[i].style.transition = '';
				}
			},
			setTransition: function(speed) {
				var swiper = this;
				for (var i = 0; i < swiper.slides.length; i++) {
					swiper.slides[i].style.transition = speed + 'ms';
					swiper.slides[i].querySelector('.paralax-slider__img').style.transition =
						speed + 'ms';
				}
			}
		}
	});

	let paralaxSlider = $('.js-paralax-slider');

	paralaxSlider.on('mouseenter', function(e){
		paralax.autoplay.stop();
	});

	paralaxSlider.on('mouseleave', function(e){
		paralax.autoplay.start();
	});
});


$('.js-history-slide').each(function () {
	let categoryThumbs = new Swiper('.js-history-thumbs', {
		spaceBetween: 0,
		slidesPerView: 9,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		centerInsufficientSlides: true,
		slideToClickedSlide: true,
		speed: 1000,
		breakpoints: {
			768: {
				slidesPerView: 1
			},
			960: {
				slidesPerView: 8
			}
		}
	});


	var history = new Swiper('.js-history-slide',{
		speed: 1000,
		thumbs: {
			swiper: categoryThumbs
		},
		autoHeight: true,
		simulateTouch: true,
		effect: 'fade',
		navigation: {
			nextEl: '.history__arrow--next',
			prevEl: '.history__arrow--prev',
		},
		on: {
			slideChange: function () {
				let activeIndex = this.activeIndex + 1;
				let nextSlide = document.querySelector(`.js-history-thumbs .swiper-slide:nth-child(${activeIndex + 1})`);
				let prevSlide = document.querySelector(`.js-history-thumbs .swiper-slide:nth-child(${activeIndex - 1})`);

				if (nextSlide && !nextSlide.classList.contains('swiper-slide-visible')) {
					this.thumbs.swiper.slideNext()
				} else if (prevSlide && !prevSlide.classList.contains('swiper-slide-visible')) {
					this.thumbs.swiper.slidePrev()
				}

			}
		}
	});
});

$('.js-award-slide').each(function () {
	var award = new Swiper('.js-award-slide', {
		loop: false,
		slidesPerView: 3.9495,
		spaceBetween: 57,
		navigation: {
			nextEl: '.js-award-next',
			prevEl: '.js-award-prev',
		},
		breakpoints: {
			480: {
				slidesPerView: 1
			},
			960: {
				slidesPerView: 'auto',
				spaceBetween: 10,
			}
		}
	})
});
